import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function StrugglePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV1.struggle.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="😰"
          label={t("pages.onboardingV1.struggle.anxiety")}
          name={t("pages.onboardingV1.struggle.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.struggle.anxiety", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="🤔"
          label={t("pages.onboardingV1.struggle.selfDoubt")}
          name={t("pages.onboardingV1.struggle.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.struggle.selfDoubt", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="🥵"
          label={t("pages.onboardingV1.struggle.burnout")}
          name={t("pages.onboardingV1.struggle.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.struggle.burnout", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-blue"
          emoji="🫥"
          label={t("pages.onboardingV1.struggle.loneliness")}
          name={t("pages.onboardingV1.struggle.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.struggle.loneliness", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-orange"
          emoji="😴"
          label={t("pages.onboardingV1.struggle.lackOfMotivation")}
          name={t("pages.onboardingV1.struggle.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.struggle.lackOfMotivation", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-green"
          emoji="🙂"
          label={t("pages.onboardingV1.struggle.feelOkay")}
          name={t("pages.onboardingV1.struggle.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.struggle.feelOkay", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
